import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

const PageNotFound = () => {
  const TIMEOUT_SCENARIOS_RELOAD = 500;
  const [isTimeToShow, setIsTimeToShow] = useState(false);

  useEffect(() => {
    const timeoutID = window.setTimeout(() => {
      setIsTimeToShow(true);
    }, TIMEOUT_SCENARIOS_RELOAD);
    return () => window.clearTimeout(timeoutID);
  }, []);

  return (
    <>
      {isTimeToShow && (
        <article style={{ padding: "100px" }}>
          <h1>Oops!</h1>
          <p>Page Not Found</p>
          <div className="flexGrow">
            <Link to="/">Visit Our Homepage</Link>
          </div>
        </article>
      )}
    </>
  );
};

export default PageNotFound;
